<template>
  <div>
    <div class="main">
      <!-- Right -->
      <div class="main_r">
        <!-- search -->
        <div class="search">
          <div>
            <el-input v-model="queryData.trainBody"  placeholder="请输入训练部位"></el-input>
            <el-date-picker v-model="queryData.timeBegin" type="date" value-format="yyyy-MM-dd" placeholder="起始时间" class="mr15"></el-date-picker>
            <el-date-picker v-model="queryData.timeEnd" type="date" value-format="yyyy-MM-dd" placeholder="结束时间" class="mr15"></el-date-picker>
            <el-button type="primary" @click="clickQuery">查询</el-button>
            <el-button type="primary" @click="clickQueryReset" plain>重置</el-button>
          </div>
        </div>
        <!-- search End -->

        <!-- 列表 -->
        <el-table :data="dataList" class="mt15" :header-cell-style="{textAlign: 'center'}" :cell-style="{ textAlign: 'center' }">
          <el-table-column prop="id" label="序号" width="80"></el-table-column>
          <el-table-column prop="trainBody" label="训练部位"></el-table-column>
          <el-table-column prop="targetTime" label="目标时长"></el-table-column>
          <el-table-column prop="finishTime" label="完成时长"></el-table-column>
          <el-table-column prop="startTime" label="开始时间"></el-table-column>
          <el-table-column prop="createTime" label="创建时间"></el-table-column>
        </el-table>

        <!-- 分页 -->
        <div class="mt20">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="page_no"
            :page-sizes="[5, 10, 15, 20]"
            :page-size="10"
            layout="prev, pager, next, sizes, jumper "
            :total="dataListnum">
          </el-pagination>
        </div>
        <!-- 分页 End -->
      </div>
      <!-- Right End -->
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import Qs from 'qs'
Vue.use(VueAxios, axios)

export default {
  components: {},
  data () {
    return {
      activeName: 'first',
      formLabelWidth: '120px',
      queryData: {
        wxUserId: '',
        trainBody: '',
        timeBegin: '',
        timeEnd: ''
      },
      // 列表
      dataList: [],
      dataListnum: 0,
      page_no: 1,
      page_size: 10,
      // 编辑
      dialogEdit: false,
      editData: {
        editId: '',
        userPassword: '',
        userName: '',
        userPhone: '',
        roleId: ''
      }
    }
  },
  mounted () {
  },
  watch:{
    "queryData.timeBegin"(newVal){
      if(newVal == null){
        this.queryData.timeBegin = ""
      }
      console.log(newVal);
    },
    "queryData.timeEnd"(newVal){
      if(newVal == null){
        this.queryData.timeEnd = ""
      }
      console.log(newVal);
    }
  },
  methods: {
    LoadData (row) {
      this.queryData.wxUserId = row.id
      this.queryData.trainBody = ''
      this.queryData.timeBegin = ''
      this.queryData.timeEnd = ''
      this.TrainPlanList()
      this.TrainPlanNum()
    },
    handleSizeChange (val) {
      this.page_size = val
      this.TrainPlanList()
      this.TrainPlanNum()
    },
    handleCurrentChange (val) {
      this.page_no = val
      this.TrainPlanList()
      this.TrainPlanNum()
    },
    clickQuery () {
      this.page_no = 1
      this.TrainPlanList()
      this.TrainPlanNum()
      console.log(this.queryData)
    },
    clickQueryReset () {
      this.queryData.trainBody = ''
      this.queryData.timeBegin = ''
      this.queryData.timeEnd = ''
      this.clickQuery()
    },
    TrainPlanList: function () {
      var that = this
      var data = Vue.prototype.FunGetBaseSignData()
      data.wxUserId = that.queryData.wxUserId
      data.trainBody = that.queryData.trainBody
      data.timeBegin = that.queryData.timeBegin
      data.timeEnd = that.queryData.timeEnd
      data.pageNo = that.page_no
      data.pageSize = that.page_size
      data.sign = Vue.prototype.FunGetSign(data)
      axios.post(Vue.prototype.global.Url_TrainPlanList, Qs.stringify(data))
        .then(function (response) {
          Vue.prototype.FunRemindOnlyError(response.data)
          if (response.data.code === 1) {
            that.dataList = response.data.data
          }
          console.log(response.data)
        })
        .catch(function (error) {
          console.log(error)
        })
    },
    TrainPlanNum: function () {
      var that = this
      var data = Vue.prototype.FunGetBaseSignData()
      data.wxUserId = that.queryData.wxUserId
      data.trainBody = that.queryData.trainBody
      data.timeBegin = that.queryData.timeBegin
      data.timeEnd = that.queryData.timeEnd
      data.sign = Vue.prototype.FunGetSign(data)
      axios.post(Vue.prototype.global.Url_TrainPlanNum, Qs.stringify(data))
        .then(function (response) {
          Vue.prototype.FunRemindOnlyError(response.data)
          if (response.data.code === 1) {
            that.dataListnum = response.data.data
          }
        })
        .catch(function (error) {
          console.log(error)
        })
    }
  }
}
</script>

<style lang="less" scoped>
.search {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 15px;

  .el-input {
    width: 300px;
    margin-right: 15px;
  }

  .el-select{
    margin-right: 15px;
  }
}

@media ( max-width: 1440px) {
  .search {
    margin-top: 15px;
    display: flex;
    align-items: center;
    justify-content: space-between;

    .el-input {
      width: 120px;
      margin-right: 15px;
    }

    .el-select{
      margin-right: 15px;
      width: 130px;
    }
  }
}

.el-table thead {
  color: #666;
}

.el-form-item {
  margin-bottom: 16px;
}

.jingwei {
  margin-top: -8px;

  .zuobiao{
    margin-bottom: -10px;

    p {
      margin: 0;
    }

    & p:nth-child(2){
      margin-top: -10px;
    }
  }
}

.position{
  overflow: hidden;
  height: 332px;
  background: #f7f7f7;
}

/deep/ .el-table thead {
  color: #373735;
  font-weight: 500;
}

/deep/ .el-table th, .el-table tr {
  background: #eff3ff;
}

.newAdd /deep/ .el-dialog__footer {
  padding: 20px;
  text-align: center;
  border-top: 1px solid #f2f2f2;
}

.newAdd /deep/ .el-dialog__header {
  padding: 15px 20px 15px;
  background: #f6f6fa;
}
.newAdd /deep/ .el-dialog__headerbtn {
  top: 20px;
}

.custom-tree-node {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 14px;
  padding-right: 8px;
}

.addUser_body{
  padding: 0 46px 0 30px;
}

/deep/ .el-button--primary {
  color: #FFF;
  background-color: #4976ff;
  border-color: #4976ff;
}

/deep/ .el-button--primary.is-plain {
  color: #4976ff;
  background: #eff3ff;
  border-color: #4976ff;
}

// 圆角处理
/deep/ thead tr th:nth-child(1) {
  border-radius: 10px 0 0 0;
}
/deep/ thead tr th:nth-last-child(2) {
  border-radius: 0 10px 0 0;
}
</style>
